import React, { useState } from 'react';
import { CgClose } from 'react-icons/cg';
import { firestore, firebase } from '../firebaseConfig';
import { TRAFFIC_SOURCES } from '../config/siteConfig';
import { usePopupManager } from './PopupManager';

const TrafficSourceModal = () => {
  const { isActive, closePopup } = usePopupManager();
  const [source, setSource] = useState('');
  const [otherText, setOtherText] = useState('');
  const [loading, setLoading] = useState(false);

  if (!isActive('traffic')) return null;

  const markTrafficDismissed = () => {
    sessionStorage.setItem('trafficSourceAnswered', '1');
    sessionStorage.setItem('trafficDismissedAt', String(Date.now()));
  };

  const handleClose = () => {
    markTrafficDismissed();
    closePopup('traffic');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!source) return;
    setLoading(true);
    try {
      await firestore.collection('trafficSources').add({
        source,
        otherText: source === 'Other' ? otherText : '',
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        page: window.location.pathname,
      });
      markTrafficDismissed();
      closePopup('traffic');
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 px-4">
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl p-6 text-left">
        <button
          type="button"
          onClick={handleClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700"
          aria-label="Close"
        >
          <CgClose size={22} />
        </button>
        <h2 className="text-xl font-bold text-gray-900 mb-1">How did you find us?</h2>
        <p className="text-sm text-gray-600 mb-5">Help us understand where our community comes from.</p>
        <form onSubmit={handleSubmit} className="space-y-3">
          {TRAFFIC_SOURCES.map((opt) => (
            <label key={opt} className="flex items-center gap-3 cursor-pointer">
              <input
                type="radio"
                name="trafficSource"
                value={opt}
                checked={source === opt}
                onChange={() => setSource(opt)}
                className="accent-amber-600"
              />
              <span className="text-sm text-gray-800">{opt}</span>
            </label>
          ))}
          {source === 'Other' && (
            <input
              type="text"
              value={otherText}
              onChange={(e) => setOtherText(e.target.value)}
              placeholder="Please specify"
              className="w-full border border-gray-300 rounded-lg p-3 text-sm outline-none focus:border-amber-500"
            />
          )}
          <button
            type="submit"
            disabled={loading || !source}
            className="w-full py-3 mt-2 bg-gradient-to-r from-amber-600 to-yellow-600 text-white font-bold rounded-full disabled:opacity-60"
          >
            {loading ? 'Submitting…' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default TrafficSourceModal;
